import { Header } from 'element';
import { useRoute, useSelectorWithProps } from 'hooks';
import { capitalize } from 'lib/helpers';
import marketLabels from 'marketLabels';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { privateRoutes } from 'routes';
import { getFlag } from 'state/Flags';
import { hasPermissionSelector } from 'state/Auth';

type RosterSettingsHeaderProps = {
  activeTab: 'general' | 'duties';
};

export function RosterSettingsHeader({ activeTab }: RosterSettingsHeaderProps) {
  const route = useRoute();
  const isDutiesEnabled = useSelector(getFlag.duties);
  const hasManagerPermission = useSelectorWithProps(
    hasPermissionSelector,
    'managerdashboard'
  );
  const { settings: settingsRoute } = privateRoutes;
  const { rosterSettings } = settingsRoute.routes;

  return (
    <Header
      title={`${capitalize(marketLabels.roster)} Settings`}
      backButton={{
        title: 'Back to Settings',
        onClick: () => {
          route.goTo(settingsRoute.path);
        },
      }}
      tabs={_.compact([
        {
          active: activeTab === 'general',
          label: 'General',
          onClick: () => {
            route.goTo(rosterSettings.routes.general.path);
          },
        },
        isDutiesEnabled && hasManagerPermission && {
          active: activeTab === 'duties',
          label: 'Duties',
          onClick: () => {
            route.goTo(rosterSettings.routes.duties.path);
          },
        },
      ])}
    />
  );
}

export default RosterSettingsHeader;

